/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import DisplayJson from "./DisplayJSON.jsx";
import {Database} from "../APIClient.jsx";
import History from "./History.jsx";
import Tooltip from "./Tooltip.jsx";
import {UI} from "../UIGenerator.jsx";
import {Util} from "../Utilities.js";
import {Socket} from "../Socket.js";
import {Subscription} from "../Subscription.js";
import {StatesAPI} from "../APIs/StatesApi.js";

class DisplayStateHistory extends Component {
    constructor() {
        super();
        this.state = {
            stateHistory: []
        }

        this.sub = new Subscription()

    }

    async fetchData() {
        let {name, elementId} = this.props
        let tableName = `STATE_${name}`
        let result = await StatesAPI.getStateHistory(name, elementId, 100)
        this.setState({stateHistory: result.sort((a, b) => (a.time - b.time))})

        this.sub.add(() => Database.table(tableName, "app").onChange((change) => {
            let history = this.state.stateHistory
            history = Socket.applyChange(history, change)
            this.setState({stateHistory: history})
        }, [{column: "elementId", value: elementId}]), "liveData")

    }

    componentDidMount() {
        this.fetchData()

        this.interval = setInterval(() => {
            this.fetchData()
        }, 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
        this.sub.unmount()

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.name !== this.props.name || prevProps.elementId !== this.props.elementId) {
            this.fetchData()
        }
    }


    render() {
        let {stateHistory} = this.state
        return (
            <>
                {/*indexKey: Util.unique.newInternalId(),*/}
                {/*state: newState,*/}
                {/*elementId: elementId,*/}
                {/*time: Util.time.now(),*/}
                {/*errors: errors*/}

                <History elements={stateHistory.map((state, index) => {

                    return ({
                        timestamp: state.time,
                        text: <span>
                            <span
                                className="font-medium text-gray-900"> {state.state} {state.state === "broken" && <>(count:{state.revalidationCount}) </>}</span>
                             <div className={"text-red-400 space-x-3 flex"}>{(state?.errors ?? []).map(error => {
                                 return <Tooltip text={error.message}
                                                 onClick={() => {
                                                     UI.drawer(Util.unique.newId(10), (state, setState, close) => {
                                                         return (<div className={"p-2"}>
                                                             <DisplayJson jsonInput={error}/>


                                                         </div>)

                                                     }, (state, close) => {
                                                         close()
                                                     }, {
                                                         title: "Error Info",
                                                         width: "80%",
                                                         button: [{
                                                             type: "abort",
                                                             text: "Abbrechen",
                                                             onClick: (inputState, setState, close) => {
                                                                 close()
                                                             }
                                                         }]
                                                     }).open()
                                                 }}
                                                 className={"border rounded border-red-500 p-1 my-1 hover:bg-red-50 cursor-pointer"}>
                                     <span>{error.code}</span>

                                 </Tooltip>
                             })}</div>
                             <div className={"text-orange-400 space-x-3 flex"}>{(state?.warnings ?? []).map(waring => {
                                 return <Tooltip text={waring.message}
                                                 onClick={() => {
                                                     UI.drawer(Util.unique.newId(10), (state, setState, close) => {
                                                         return (<div className={"p-2"}>
                                                             <DisplayJson jsonInput={waring}/>


                                                         </div>)

                                                     }, (state, close) => {
                                                         close()
                                                     }, {
                                                         title: "Warning Info",
                                                         width: "80%",
                                                         button: [{
                                                             type: "abort",
                                                             text: "Abbrechen",
                                                             onClick: (inputState, setState, close) => {
                                                                 close()
                                                             }
                                                         }]
                                                     }).open()
                                                 }}
                                                 className={"border rounded border-orange-500 p-1 my-1 hover:bg-orange-50 cursor-pointer"}>
                                     <span>{waring.code}</span>

                                 </Tooltip>
                             })}</div>
                             <div className={"text-blue-400 space-x-3 flex"}>{(state?.infos ?? []).map(info => {
                                 return <Tooltip text={info.message}
                                                 onClick={() => {
                                                     UI.drawer(Util.unique.newId(10), (state, setState, close) => {
                                                         return (<div className={"p-2"}>
                                                             <DisplayJson jsonInput={info}/>


                                                         </div>)

                                                     }, (state, close) => {
                                                         close()
                                                     }, {
                                                         title: "Info",
                                                         width: "80%",
                                                         button: [{
                                                             type: "abort",
                                                             text: "Abbrechen",
                                                             onClick: (inputState, setState, close) => {
                                                                 close()
                                                             }
                                                         }]
                                                     }).open()
                                                 }}
                                                 className={"border rounded border-blue-500 p-1 my-1 hover:bg-blue-50 cursor-pointer"}>
                                     <span>{info.code}</span>

                                 </Tooltip>
                             })}</div>

                            {state.state.startsWith("inSetup") && (<>
                                {index + 1 !== stateHistory.length ? (<>
                                    <div className={"opacity-0 hover:opacity-100 opacity-100"}>duration in
                                        state: {Math.round((stateHistory?.[index + 1]?.time ?? 0) - state.time)}s
                                    </div>

                                </>) : (<div>
                                    Ongoing:


                                </div>)}
                            </>)}


                        </span>
                    })
                })}/>

            </>
        );
    }
}

DisplayStateHistory.propTypes = {};

DisplayStateHistory.defaultProps = {};


export default DisplayStateHistory;